// eslint-disable-next-line no-restricted-imports
import store from '../vuex/store';
import { createVocItem } from '@utils/voc.utils';
import { hasResponseAlreadyBecomeFeedbackItem } from '@pendo/one-ui-shared';

export async function createFeedbackItemFromNPSResponse (npsResponse, sourceIdentifier, npsGuide) {
    const guideProductAreas = [];
    const productArea = store.getters['groups/groupByGuideId']({ guideId: npsGuide.id });
    if (productArea) {
        guideProductAreas.push(productArea);
    }
    const initialFormData = getInitialFormDataForVocItemCreatedFromNPSResponse(npsResponse, npsGuide);
    const formDataQuestion = ['', npsGuide.polls[1].question, npsGuide.polls[0].question];
    const newVocItem = createVocItem({
        status: store.getters['statuses/list']('feedback')[0]?.id,
        initialFormData,
        formDataQuestion,
        guide: npsGuide,
        pollResponseRow: npsResponse,
        guideProductAreas,
        sourceIdentifier,
        source: 'NPS',
    });

    return store.dispatch('vocItems/createVocItem', {
        vocItem: newVocItem,
        storeInMap: false,
    });
}

function getInitialFormDataForVocItemCreatedFromNPSResponse (npsResponse, guide) {
    return [
        {
            title: 'Title',
            prompt: 'Example: "A Slack Integration"',
            label: 'Title',
            content: `Feedback from ${guide.name}`,
            type: 'short text',
            required: true,
        },
        {
            title: 'What is the customer trying to achieve?',
            prompt: 'Explain their goal and their current workaround',
            label: 'Goal',
            content: npsResponse.followUpResponse,
            type: 'long text',
            required: false,
        },
        {
            title: 'Score',
            prompt: '',
            label: 'Score',
            content: `${npsResponse.pollResponse}`,
            type: 'integer',
            required: false,
        },
    ];
}

export function getMultiPollResponseSourceIdentifier (multiPollResponse) {
    return `${multiPollResponse.guideId}__${multiPollResponse.visitorId}__${multiPollResponse.browserTime}`;
}

export function hasMultiPollResponseAlreadyBecomeFeedbackItem (multiPollResponse, alreadyLinkedResponses) {
    const multiPollResponseId = getMultiPollResponseSourceIdentifier(multiPollResponse);

    return hasResponseAlreadyBecomeFeedbackItem(multiPollResponseId, alreadyLinkedResponses);
}

export function isMultiPollSendToFeedbackInProgress (multiPollResponse, creatingFeedbackInProgress) {
    const multiPollResponseId = getMultiPollResponseSourceIdentifier(multiPollResponse);

    return creatingFeedbackInProgress.includes(multiPollResponseId);
}

export function formatPollQuestion (question) {
    const filteredStr = question.replace(/\n/g, '');
    if (filteredStr.trim() === '') {
        return 'Untitled question';
    }

    return question;
}

export function aiAnalyzeFlag (sendToAI, subObjectIdsToSendToAI, pollId) {
    if (!sendToAI) {
        return null;
    }
    if (subObjectIdsToSendToAI.includes(pollId)) {
        return 'analyze';
    }

    return 'do-not-analyze';
}

export function roundResponseCount (count) {
    if (count < 5) {
        return `${count} (approx)`;
    }

    if (count < 100) {
        return `${Math.round(count / 10) * 10} (approx)`;
    }

    return `${Math.round(count / 50) * 50} (approx)`;
}
